import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenGroupActivitiesIndicatorB4 } from "@/services/esus/indicator/esb/b4/getDetailedCitizenGroupActivitiesIndicatorB4";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsbB4CitizenHistoryItem } from "./IndicatorEsbB4CitizenHistoryItem";
import { IndicatorEsbB4CitizenHistoryInfo } from "./IndicatorEsbB4CitizenHistoryInfo";

type IndicatorEsbB4CitizenHistoryProps = {
	citizenWithGroupActivities: DetailedCitizenGroupActivitiesIndicatorB4;
};

export function IndicatorEsbB4CitizenHistory({
	citizenWithGroupActivities,
}: Readonly<IndicatorEsbB4CitizenHistoryProps>) {
	const indicatorEsbB4CitizenHistoryInfo = {
		fullName: citizenWithGroupActivities.fullName ? citizenWithGroupActivities.fullName : "N/A",
		birthdate: citizenWithGroupActivities.birthdate
			? dayjs(citizenWithGroupActivities.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithGroupActivities.birthdate
			? getAge(dayjs(citizenWithGroupActivities.birthdate))
			: "",
		document: citizenWithGroupActivities.cpf
			? formatIdentifier(citizenWithGroupActivities.cpf)
			: citizenWithGroupActivities.cns ?? "",
		motherName: citizenWithGroupActivities.motherName ?? "",
		phone: citizenWithGroupActivities.phone
			? phoneFormat(citizenWithGroupActivities.phone)
			: "",
		address:
			addressConcat(
				citizenWithGroupActivities.street,
				citizenWithGroupActivities.houseNumber,
				citizenWithGroupActivities.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsbB4CitizenHistoryInfo {...indicatorEsbB4CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Atividades coletivas de escovação supervisionada"
				timeLineContents={(
					citizenWithGroupActivities.groupActivityCitizens ?? []
				).map<TimeLineContent>((groupActivity) => {
					return {
						content: <IndicatorEsbB4CitizenHistoryItem groupActivity={groupActivity} />,
						eventDate: groupActivity.registerDate
							? dayjs(groupActivity.registerDate).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
